import React, { useState, useEffect } from "react";
import AppsTable from "../../components/AppsTable";
import LoadingSpinner from "../../components/LoadingSpinner";
import TransxTable from "../../components/TransxTable";
import { instance as axios } from "../../utils/axiosConfig";
import { useQuery } from "@tanstack/react-query";

export default function Dashboard() {
  const fetchPayments = async () => {
    try {
      const resp = await axios.get("/user-payments");
      const analyticsRes = await axios.get("/user-analytics");
      return { payments: resp.data.reverse(), analytics: analyticsRes.data };
    } catch (error) {
      console.log(error);
    }
  };

  const { data, isLoading: loading } = useQuery(["dashboard"], fetchPayments);

  return (
    <div>
      {loading ? (
        <LoadingSpinner />
      ) : (
        <>
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
            <div className="p-4 bg-yellow-100 rounded-xl text-gray-800">
              <div className="font-bold text-xl leading-none">
                {data?.analytics?.allApps}
              </div>
              <div className="mt-2">All Apps</div>
            </div>
            <div className="p-4 bg-yellow-100 rounded-xl text-gray-800">
              <div className="font-bold text-xl leading-none">
                {data?.analytics?.allLinks}
              </div>
              <div className="mt-2">All Links</div>
            </div>
            <div className="p-4 bg-yellow-100 rounded-xl text-gray-800">
              <div className="font-bold text-xl leading-none">
                {data?.analytics?.totalTransactions}
              </div>
              <div className="mt-2">Total Transacted</div>
            </div>
            <div className="p-4 bg-yellow-100 rounded-xl text-gray-800">
              <div className="font-bold text-xl leading-none">
                {data?.analytics?.totalLinkTransactions}
              </div>
              <div className="mt-2">Total Link Transactions</div>
            </div>
          </div>
          <div className="my-6">
            <h1>My payments</h1>
            <div className="">
              <TransxTable transactions={data?.payments} />
            </div>
          </div>
        </>
      )}
    </div>
  );
}
